import { CountryFlagIcon48 } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React from 'react';
import { style as wineStyle } from 'vivino-js/apiPropTypes';
import Anchor from 'vivino-js/atoms/Anchor';
import t from 'vivino-js/translationString';
import { wineStyleUrl } from 'vivino-js/vivinoUrls';

import { Col, Grid, Row } from 'vivino-ui/components/Grid';

import stylesheet from './wineTasteStyle.mobile.scss';

const TRANSLATIONS = {
  wineStyle: 'components.shared.wine_taste_style.wine_style',
  readMore: 'components.shared.wine_taste_style.read_more',
};

export default function WineTasteStyleMobile({ img, descriptionAsTags, styleData }) {
  return (
    <>
      <Grid>
        <Row>
          <Col>
            <div className={stylesheet.meta}>
              <h2 className={stylesheet.wineStyle}>{t(TRANSLATIONS.wineStyle)}</h2>
              <h3 className={stylesheet.wineName}>{styleData.name}</h3>
              <div className={stylesheet.countryContainer}>
                <div className={stylesheet.countryIcon}>
                  <CountryFlagIcon48 countryCode={styleData.country.code} />
                </div>
                <div className={stylesheet.countryName}>{styleData.country.name}</div>
              </div>
            </div>
          </Col>
        </Row>
      </Grid>
      {img && (
        <div
          style={{ backgroundImage: `url(${img})` }}
          className={stylesheet.backgroundBlock}
          data-testid="WineTasteStyle"
        />
      )}
      <Grid>
        <Row>
          <Col>
            <article className={stylesheet.description}>{descriptionAsTags}</article>
            <Anchor className={stylesheet.readMore} href={wineStyleUrl({ wineStyle: styleData })}>
              {t(TRANSLATIONS.readMore)}
            </Anchor>
          </Col>
        </Row>
      </Grid>
    </>
  );
}

WineTasteStyleMobile.propTypes = {
  styleData: wineStyle,
  descriptionAsTags: PropTypes.array,
  img: PropTypes.string,
};
